const templatesData = [
  {
    status: 'Approved',
    title: 'Template_1',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: '',
  },
  {
    status: 'Approved',
    title: 'Template_2',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: 'image',
  },
  {
    status: 'Approved',
    title: 'Template_3',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: 'link',
  },
  {
    status: 'Approved',
    title: 'Template_4',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: 'media',
  },
];

export const _teamStatus = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
];

export const _status = [`Open`, `Colsed`];

export const _userStatus = ['ACTIVE', 'INACTIVE'];

export const _businessIndustry = [
  { value: 'technology', label: 'TECHNOLOGY' },
  { value: 'healthcare', label: 'HEALTHCARE' },
  { value: 'finance', label: 'FINANCE' },
  { value: 'retail', label: 'RETAIL' },
  { value: 'manufacturing', label: 'MANUFACTURING' },
];

export const _companySize = [
  { value: '1-10', label: '1-10_EMPLOYEES' },
  { value: '11-50', label: '11-50_EMPLOYEES' },
  { value: '51-200', label: '51-200_EMPLOYEES' },
  { value: '201-500', label: '201-500_EMPLOYEES' },
  { value: '501-1000', label: '501-1000_EMPLOYEES' },
];

export const _templateList = templatesData.map((_, index) => ({
  ..._,
  id: index.toString(),
  templateName: _.title,
  templateMsg: _.message,
}));

export const _priorityOptions = [
  { label: 'LOW', value: 'low' },
  { label: 'NORMAL', value: 'normal' },
  { label: 'HIGH', value: 'high' },
];

export const _statusOptions = [
  { label: 'OPEN', value: 'open' },
  { label: 'IN_PROGRESS', value: 'in progress' },
  { label: 'ON_HOLD', value: 'on hold' },
  { label: 'COMPLETED', value: 'completed' },
];

export const channelStep1Data = (t: any) => [
  {
    channel_name: t('WHATSAPP_BUSINESS'),
    value: 'WHATSAPP',
    icon: '/assets/icons/navbar/ic-variance-whatsapp-business.svg',
    description: t('WHATSAPP_DESCRIPTION'),
    category: 'MESSAGING',
  },
  {
    channel_name: t('EMAIL'),
    value: 'EMAIL',
    icon: '/assets/icons/navbar/ic-variance-mail.svg',
    description: t('EMAIL_DESCRIPTION'),
    category: 'MESSAGING',
  },
  {
    channel_name: t('LIVE_CHAT'),
    value: 'LIVE_CHAT',
    icon: '/assets/icons/navbar/ic-variance-livechat.svg',
    description: t('LIVE_CHAT_DESCRIPTION'),
    category: 'MESSAGING',
  },
  {
    channel_name: t('DID_VOICE'),
    value: 'VOICE',
    icon: '/assets/icons/navbar/ic-variance-voice.svg',
    description: t('VOICE_DESCRIPTION'),
    category: 'VOICE',
  },
  {
    channel_name: t('MESSENGER'),
    value: 'MESSENGER',
    icon: '/assets/icons/navbar/ic-variance-facebook.svg',
    description: t('MESSENGER_DESCRIPTION'),
    category: 'SOCIAL',
  },
  {
    channel_name: t('INSTAGRAM'),
    value: 'INSTAGRAM',
    icon: '/assets/icons/navbar/ic-variance-instagram.svg',
    description: t('INSTAGRAM_DESCRIPTION'),
    category: 'SOCIAL',
  },
  // {
  //   channel_name: t('SMS'),
  //   value: 'SMS',
  //   icon: '/assets/icons/navbar/ic-variance-sms.svg',
  //   description: t('SMS_DESCRIPTION'),
  //   category: 'MESSAGING',
  // },
  // {
  //   channel_name: t('LINE'),
  //   value: 'LINE',
  //   icon: '/assets/icons/navbar/ic-variance-line.svg',
  //   description: t('LINE_DESCRIPTION'),
  //   category: 'SOCIAL',
  // },
  // {
  //   channel_name: t('TELEGRAM'),
  //   value: 'TELEGRAM',
  //   icon: '/assets/icons/navbar/ic-variance-telegram.svg',
  //   description: t('TELEGRAM_DESCRIPTION'),
  //   category: 'SOCIAL',
  // },
  // {
  //   channel_name: t('TEAMS'),
  //   value: 'MICROSOFTTEAMS',
  //   icon: '/assets/icons/navbar/ic-variance-teams.svg',
  //   description: t('TEAMS_DESCRIPTION'),
  // },
];

export const emailStep1Data = (t: any) => [
  {
    channel_name: t('MICROSOFT'),
    value: 'microsoft',
    icon: '/assets/icons/navbar/ic-microsoft.svg',
    description: t('CONNECT_WITH_MICROSOFT_ACCOUNT'), // example description
    isPopular: true, // popular provider
  },
  {
    channel_name: t('GOOGLE'),
    value: 'google',
    icon: '/assets/icons/navbar/ic-gmail.svg',
    description: t('CONNECT_WITH_GOOGLE_ACCOUNT'),
    isPopular: true,
  },
  {
    channel_name: t('OTHER_PROVIDERS'),
    value: 'other_provider',
    icon: '/assets/icons/navbar/ic-mail.svg',
    description: t('CONNECT_WITH_OTHER_EMAIL_PROVIDER'),
    isPopular: false,
  },
];

export const smsStep1Data = (t: any) => [
  {
    channel_name: t('TWILIO'),
    value: 'twilio',
    icon: '/assets/icons/navbar/ic-twilio.svg',
    description: t(
      'Global cloud communications platform with robust APIs, high deliverability rates, and comprehensive developer tools for scalable messaging solutions.'
    ),
  },
  {
    channel_name: t('PLIVO'),
    value: 'plivo',
    icon: '/assets/icons/navbar/ic-plivo.svg',
    description: t(
      'Voice and SMS API platform offering flexible pricing, powerful features, and reliable infrastructure for business communications worldwide.'
    ),
  },
];

// Custom Fields Constants
export const _fieldTypeEnum = {
  TEXT: 'text',
  NUMBER: 'number',
  SELECT: 'select',
  MULTI_SELECT: 'multiSelect',
  CHECKBOX: 'boolean',
  DATE: 'date',
  TIME: 'time',
  DATETIME: 'dateTime',
  CUSTOM: 'custom',
  DYNAMIC_SELECT: 'dynamicSelect',
  MULTI_ASSIGN_SELECT: 'multiAssignSelect',
  EMAIL: 'email',
} as const;

export const _fieldTypes = Object.keys(_fieldTypeEnum).map((key) => ({
  value: _fieldTypeEnum[key as keyof typeof _fieldTypeEnum],
  label: key,
}));

export type FieldType = (typeof _fieldTypeEnum)[keyof typeof _fieldTypeEnum];

// ========================================
export const _customFieldTypeEnum = {
  TEXT: 'text',
  NUMBER: 'number',
  SELECT: 'select',
  MULTI_SELECT: 'multiSelect',
  CHECKBOX: 'boolean',
} as const;

export const _customFieldTypes = Object.keys(_customFieldTypeEnum).map((key) => ({
  value: _customFieldTypeEnum[key as keyof typeof _customFieldTypeEnum],
  label: key,
}));
// ========================================

export const modifiedTypes = {
  text: 'text',
  number: 'text',
  select: 'select',
  multiSelect: 'multiSelect',
  boolean: 'boolean',
  date: 'date',
  time: 'time',
  dateTime: 'dateTime',
  custom: 'custom',
  action: 'action',
  email: 'text',
};

export const _dateFormats = [
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'YYYY/MM/DD', label: 'YYYY/MM/DD' },
];

export const _timeFormats = [
  { value: 'HH:mm', label: '24_HOUR_FORMAT' },
  { value: 'hh:mm A', label: '12_HOUR_FORMAT' },
];

export const _dateTimeFormats = [
  { value: 'MM/DD/YYYY HH:mm', label: 'MM/DD/YYYY_24_HOUR' },
  { value: 'MM/DD/YYYY hh:mm A', label: 'MM/DD/YYYY_12_HOUR' },
  { value: 'DD/MM/YYYY HH:mm', label: 'DD/MM/YYYY_24_HOUR' },
  { value: 'DD/MM/YYYY hh:mm A', label: 'DD/MM/YYYY_12_HOUR' },
  { value: 'YYYY/MM/DD HH:mm', label: 'YYYY/MM/DD_24_HOUR' },
  { value: 'YYYY/MM/DD hh:mm A', label: 'YYYY/MM/DD_12_HOUR' },
];

// Dropdown options with translation support
export const getDropdownOptions = (t: (key: string) => string) => ({
  TICKET: {
    status: [
      { label: t('OPEN'), value: 'open' },
      { label: t('IN_PROGRESS'), value: 'in progress' },
      { label: t('ON_HOLD'), value: 'on hold' },
      { label: t('COMPLETED'), value: 'completed' },
    ],
    priority: [
      { label: t('LOW'), value: 'low' },
      { label: t('NORMAL'), value: 'normal' },
      { label: t('HIGH'), value: 'high' },
    ],
  },
  CAMPAIGN: {
    status: [
      { label: t('CREATED'), value: 'created' },
      { label: t('RUNNING'), value: 'running' },
      { label: t('COMPLETED'), value: 'completed' },
    ],
  },
  TENANTS: {
    status: [],
  },
  call: {
    status: [
      { label: t('FAILED'), value: 'FAILED' },
      { label: t('ANSWERED'), value: 'ANSWERED' },
      { label: t('NO_ANSWER'), value: 'NO ANSWER' },
      { label: t('BUSY'), value: 'BUSY' },
      { label: t('CONGESTION'), value: 'CONGESTION' },
    ],
    direction: [
      { label: t('INTERNAL'), value: 'Internal' },
      { label: t('INCOMING'), value: 'Incoming' },
      { label: t('OUTGOING'), value: 'Outgoing' },
      { label: t('TRANSIT'), value: 'Transit' },
    ],
  },
  user: {
    status: [
      { label: t('ACTIVE'), value: 'ACTIVE' },
      { label: t('INACTIVE'), value: 'INACTIVE' },
    ],
  },
  team: {
    status: [
      { label: t('ACTIVE'), value: 'ACTIVE' },
      { label: t('INACTIVE'), value: 'INACTIVE' },
    ],
  },
  template: {
    status: [
      { label: t('PENDING'), value: 'PENDING' },
      { label: t('APPROVED'), value: 'APPROVED' },
      { label: t('REJECTED'), value: 'REJECTED' },
      { label: t('PAUSED'), value: 'PAUSED' },
      { label: t('DISABLED'), value: 'DISABLED' },
    ],
  },
  conversation: {
    status: [
      { label: t('OPEN'), value: 'OPEN' },
      { label: t('CLOSE'), value: 'CLOSED' },
    ],
    channelType: [
      { label: t('WHATSAPP'), value: 'WHATSAPP' },
      { label: t('EMAIL'), value: 'EMAIL' },
      { label: t('LIVE_CHAT'), value: 'LIVE_CHAT' },
      { label: t('SMS'), value: 'SMS' },
      { label: t('LINE'), value: 'LINE' },
      { label: t('TELEGRAM'), value: 'TELEGRAM' },
      { label: t('TEAMS'), value: 'MICROSOFTTEAMS' },
    ],
  },
  inbox: {
    status: [
      { label: t('OPEN'), value: 'OPEN' },
      { label: t('CLOSE'), value: 'CLOSED' },
    ],
  },
  AUDIT_LOG: {
    actions: [
      { label: t('CREATE'), value: 'CREATE' },
      { label: t('UPDATE'), value: 'UPDATE' },
      { label: t('FIELD_UPDATE'), value: 'FIELD_UPDATE' },
      { label: t('DELETE'), value: 'DELETE' },
      { label: t('BULK_DELETE'), value: 'BULK_DELETE' },
      // { label: t('MERGE'), value: 'MERGE' },
      // { label: t('SPLIT'), value: 'SPLIT' },
      // { label: t('ASSIGN'), value: 'ASSIGN' },
      // { label: t('UNASSIGN'), value: 'UNASSIGN' },
      // { label: t('IMPORT'), value: 'IMPORT' },
      // { label: t('EXPORT'), value: 'EXPORT' },
      // { label: t('STATUS_CHANGE'), value: 'STATUS_CHANGE' },
      // { label: t('VIEW'), value: 'VIEW' },
      { label: t('CREATE_FAILED'), value: 'CREATE_FAILED' },
      { label: t('UPDATE_FAILED'), value: 'UPDATE_FAILED' },
      { label: t('DELETE_FAILED'), value: 'DELETE_FAILED' },
      // { label: t('VIEW_FAILED'), value: 'VIEW_FAILED' },
      // { label: t('IMPORT_FAILED'), value: 'IMPORT_FAILED' },
      // { label: t('EXPORT_FAILED'), value: 'EXPORT_FAILED' },
      // { label: t('STATUS_CHANGE_FAILED'), value: 'STATUS_CHANGE_FAILED' },
      // { label: t('ASSIGN_FAILED'), value: 'ASSIGN_FAILED' },
      // { label: t('UNASSIGN_FAILED'), value: 'UNASSIGN_FAILED' },
      // { label: t('LOGIN'), value: 'LOGIN' },
      // { label: t('LOGOUT'), value: 'LOGOUT' },
      // { label: t('PASSWORD_RESET'), value: 'PASSWORD_RESET' },
      // { label: t('INVITE_USER'), value: 'INVITE_USER' },
      // { label: t('ACCEPT_INVITE'), value: 'ACCEPT_INVITE' },
    ],
    modules: [
      // { label: t('SNIPPET'), value: 'SNIPPET' },
      { label: t('CONTACT'), value: 'CONTACT' },
      { label: t('TICKET'), value: 'TICKET' },
      { label: t('ACCOUNT'), value: 'COMPANY' },
      // { label: t('TEAM'), value: 'TEAM' },
      { label: t('USER'), value: 'USER' },
      // { label: t('WEBHOOK'), value: 'WEBHOOK' },
      // { label: t('CAMPAIGN'), value: 'CAMPAIGN' },
      // { label: t('TENANT'), value: 'TENANT' },
      // { label: t('CHANNEL'), value: 'CHANNEL' },
    ],
  },
});

// Helper for type inference if needed (optional)
// Helper for type inference if needed (optional)
// export type DropdownOptionsType = ReturnType<typeof getDropdownOptions>;

// Mock User Data
export const MOCK_USER = {
  id: '8864c717-587d-472a-929a-8e5f298024da-0',
  displayName: 'Jaydon Frankie',
  email: 'demo@minimals.cc',
  photoURL: 'https://api-dev-minimal-v6.vercel.app/assets/images/mock/avatar/avatar-25.webp',
  phoneNumber: '+1 202-555-0143',
  country: 'United States',
  address: '90210 Broadway Blvd',
  state: 'California',
  city: 'San Francisco',
  zipCode: '94116',
  about: 'Praesent turpis. Phasellus viverra nulla ut metus varius laoreet. Phasellus tempus.',
  role: 'admin',
  isPublic: true,
};

// Mock Roles
export const _roles = [
  'Agent',
  'Admin',
  'CEO',
  'CTO',
  'Project Coordinator',
  'Team Leader',
  'Software Developer',
  'Marketing Strategist',
  'Data Analyst',
  'Product Owner',
  'Graphic Designer',
  'Operations Manager',
  'Customer Support Specialist',
  'Sales Manager',
  'HR Recruiter',
  'Business Consultant',
  'Financial Planner',
  'Network Engineer',
  'Content Creator',
  'Quality Assurance Tester',
  'Public Relations Officer',
  'IT Administrator',
  'Compliance Officer',
  'Event Planner',
  'Legal Counsel',
  'Training Coordinator',
];

// Mock Contacts
export const _contacts = [
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
    status: 'online',
    role: 'Agent',
    email: 'nannie.abernathy70@yahoo.com',
    name: 'Jayvion Simon',
    phoneNumber: '+1 202-555-0143',
    lastActivity: '2026-02-18T10:30:00Z',
    avatarUrl: 'https://api-dev-minimal-v6.vercel.app/assets/images/mock/avatar/avatar-1.webp',
    address: '19034 Verna Unions Apt. 164 - Honolulu, RI / 87535',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2',
    status: 'busy',
    role: 'Admin',
    email: 'ashlynn.ohara62@gmail.com',
    name: 'Lucian Obrien',
    phoneNumber: '+1 416-555-0198',
    lastActivity: '2026-02-17T09:15:00Z',
    avatarUrl: 'https://api-dev-minimal-v6.vercel.app/assets/images/mock/avatar/avatar-2.webp',
    address: '1147 Rohan Drive Suite 819 - Burlington, VT / 82021',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3',
    status: 'offline',
    role: 'CEO',
    email: 'milo.farrell@hotmail.com',
    name: 'Deja Brady',
    phoneNumber: '+44 20 7946 0958',
    lastActivity: '2026-02-16T14:45:00Z',
    avatarUrl: 'https://api-dev-minimal-v6.vercel.app/assets/images/mock/avatar/avatar-3.webp',
    address: '18605 Thompson Circle Apt. 086 - Idaho Falls, WV / 50337',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4',
    status: 'always',
    role: 'CTO',
    email: 'violet.ratke86@yahoo.com',
    name: 'Harrison Stein',
    phoneNumber: '+61 2 9876 5432',
    lastActivity: '2026-02-15T11:20:00Z',
    avatarUrl: 'https://api-dev-minimal-v6.vercel.app/assets/images/mock/avatar/avatar-4.webp',
    address: '110 Lamar Station Apt. 730 - Hagerstown, OK / 49808',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5',
    status: 'online',
    role: 'Project Coordinator',
    email: 'letha.lubowitz24@yahoo.com',
    name: 'Reece Chung',
    phoneNumber: '+91 22 1234 5678',
    lastActivity: '2026-02-14T16:00:00Z',
    avatarUrl: 'https://api-dev-minimal-v6.vercel.app/assets/images/mock/avatar/avatar-5.webp',
    address: '36901 Elmer Spurs Apt. 762 - Miramar, DE / 92836',
  },
];

// Mock Audience List
export const _audienceList = [
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
    name: 'John Doe',
    number: '+1 555-1234',
    email: 'johndoe@example.com',
    city: 'New York',
    state: 'NY',
    label: 'VIP',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2',
    name: 'Jane Smith',
    number: '+1 555-5678',
    email: 'janesmith@example.com',
    city: 'Los Angeles',
    state: 'CA',
    label: 'New Custom',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3',
    name: 'Michael Brown',
    number: '+1 555-8765',
    email: 'michaelbrown@example.com',
    city: 'Chicago',
    state: 'IL',
    label: 'High Priority',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4',
    name: 'Emily Johnson',
    number: '+1 555-4321',
    email: 'emilyjohnson@example.com',
    city: 'Houston',
    state: 'TX',
    label: 'VIP',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5',
    name: 'David Lee',
    number: '+1 555-6543',
    email: 'davidlee@example.com',
    city: 'San Francisco',
    state: 'CA',
    label: 'New Custom',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6',
    name: 'Sarah Miller',
    number: '+1 555-9876',
    email: 'sarahmiller@example.com',
    city: 'Miami',
    state: 'FL',
    label: 'High Priority',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7',
    name: 'Robert Wilson',
    number: '+1 555-2468',
    email: 'robertwilson@example.com',
    city: 'Seattle',
    state: 'WA',
    label: 'VIP',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8',
    name: 'Olivia Martinez',
    number: '+1 555-3697',
    email: 'oliviamartinez@example.com',
    city: 'Denver',
    state: 'CO',
    label: 'New Custom',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9',
    name: 'Daniel Anderson',
    number: '+1 555-1597',
    email: 'danielanderson@example.com',
    city: 'Boston',
    state: 'MA',
    label: 'High Priority',
  },
  {
    id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10',
    name: 'Sophia Thomas',
    number: '+1 555-7531',
    email: 'sophiathomas@example.com',
    city: 'Dallas',
    state: 'TX',
    label: 'VIP',
  },
];
